import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'Spark',
  price: '499',
  description: 'Essential tools for small businesses and startups.',
  features: ['Up to 10,000 PLN monthly ad spend', 'Nexus AI Basic Optimization', 'Daily Performance Reports', 'Email Support', '1 User Seat'],
  cta: 'Start Free Trial',
  variant: 'secondary' as const
}, {
  name: 'Ignite',
  price: '1,499',
  description: 'Advanced power for growing marketing teams.',
  features: ['Up to 50,000 PLN monthly ad spend', 'Nexus AI Pro Optimization', 'Real-time Prism Analytics', 'Priority Chat Support', '5 User Seats', 'A/B Testing Suite'],
  cta: 'Get Started',
  variant: 'primary' as const,
  highlighted: true
}, {
  name: 'Supernova',
  price: '4,999',
  description: 'Full-scale solution for enterprise organizations.',
  features: ['Unlimited ad spend', 'Custom AI Model Training', 'Dedicated Account Manager', 'API Access', 'Unlimited Seats', 'White-label Reports', 'SLA Guarantee'],
  cta: 'Contact Sales',
  variant: 'secondary' as const
}];
export function Pricing() {
  return <section id="pricing" className="py-24 bg-slate-950 relative" data-id="element-210">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-emerald-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-211" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-214">
            Transparent Pricing
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-215">
            Choose the power level that fits your growth trajectory. No hidden
            fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-216">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={tier.highlighted ? 'md:-mt-8' : ''} data-id="element-217">
              <Card className={`p-8 h-full flex flex-col ${tier.highlighted ? 'bg-slate-800 border-emerald-500/50 shadow-2xl shadow-emerald-900/20' : 'bg-slate-900 border-slate-800'}`} data-id="element-218">
                {tier.highlighted && <div className="inline-block px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-400 text-xs font-bold uppercase tracking-wider mb-4 w-fit" data-id="element-219">
                    Most Popular
                  </div>}

                <h3 className="text-xl font-bold text-white mb-2" data-id="element-220">
                  {tier.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-4" data-id="element-221">
                  <span className="text-4xl font-bold text-white" data-id="element-222">
                    {tier.price}
                  </span>
                  <span className="text-slate-500" data-id="element-223">PLN / mo</span>
                </div>
                <p className="text-slate-400 text-sm mb-8" data-id="element-224">
                  {tier.description}
                </p>

                <div className="flex-1 space-y-4 mb-8" data-id="element-225">
                  {tier.features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-226">
                      <Check className="w-5 h-5 text-emerald-500 shrink-0" data-id="element-227" />
                      <span className="text-slate-300 text-sm" data-id="element-228">{feature}</span>
                    </div>)}
                </div>

                <Button variant={tier.variant} className="w-full" data-id="element-229">
                  {tier.cta}
                </Button>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}